module.exports = __webpack_public_path__ + "assets/bff8399c12eb763518032b4e3e10370c.mp3";